import { Col, Input, Row, Select } from "antd";
import React, { ChangeEvent } from "react";
import { CredentialBeingCreated } from "../../../types/credentials";

export interface EditCredentialModalProps {
  roles: string[];
  credential: CredentialBeingCreated;
  setCredential: (credential: CredentialBeingCreated) => void;
}

const CreateCredentialView = (props: EditCredentialModalProps) => {
  const options = props.roles.map((role) => {
    return {
      label: role,
      value: role,
    };
  });

  const changeUsername = (value: string) => {
    props.setCredential(
      new CredentialBeingCreated(
        value,
        props.credential.password,
        props.credential.roles
      )
    );
  };

  const changePassword = (value: string) => {
    props.setCredential(
      new CredentialBeingCreated(
        props.credential.userName,
        value,
        props.credential.roles
      )
    );
  };

  const changeRoles = (selectedRoles: string[]) => {
    props.setCredential(
      new CredentialBeingCreated(
        props.credential.userName,
        props.credential.password,
        selectedRoles
      )
    );
  };

  return (
    <div>
      <Row>
        <Col span={12}>UserName</Col>
        <Col span={12}>
          <Input
            value={props.credential.userName}
            onChange={(value: ChangeEvent<HTMLInputElement>) =>
              changeUsername(value.target.value)
            }
          />
        </Col>
      </Row>
      <Row style={{ marginTop: "5px" }}>
        <Col span={12}>Password</Col>
        <Col span={12}>
          <Input.Password
            value={props.credential.password}
            onChange={(value: ChangeEvent<HTMLInputElement>) =>
              changePassword(value.target.value)
            }
          />
        </Col>
      </Row>
      <Row>
        <Col span={12}>Roles</Col>
        <Col span={12}>
          <Select
            mode={"multiple"}
            options={options}
            value={props.credential.roles}
            onChange={changeRoles}
            style={{ width: "100%" }}
          ></Select>
        </Col>
      </Row>
      <Row></Row>
    </div>
  );
};

export default CreateCredentialView;
